/**
 * Dev-only logger.
 *
 * Wraps console methods so they are silenced in production.
 * The NODE_ENV check is evaluated once at module load; Webpack DefinePlugin
 * dead-code-eliminates the real implementations in production builds.
 */

const noop = (): void => {};
const isDev = process.env.NODE_ENV !== 'production';

export const log: (...args: any[]) => void = isDev ? console.log.bind(console) : noop;
export const warn: (...args: any[]) => void = isDev ? console.warn.bind(console) : noop;
export const group: (...args: any[]) => void = isDev ? console.group.bind(console) : noop;
export const groupEnd: () => void = isDev ? console.groupEnd.bind(console) : noop;
